import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrashAlt,
  faEdit,
  faQuestionCircle,
  faCopy,
  faPlus,
  faInfoCircle,
  faChevronDown,
  faChevronUp,
  faSortUp,
  faSortDown,
  faSort,
  faSearch,
  faBoxOpen,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFile,
  faUserCircle,
  faUserAlt,
  faSignOutAlt,
  faHome,
  faMinus,
  faCheck,
  faEnvelope,
  faCube,
  faBars,
  faChartLine,
  faToggleOn,
  faStar,
  faPaperclip,
  faTimes,
  faShare,
  faWarehouse,
  faFileUpload,
  faFileSignature
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'

library.add([
  faTrashAlt,
  faEdit,
  faQuestionCircle,
  faCopy,
  faPlus,
  faInfoCircle,
  faChevronDown,
  faChevronUp,
  faSortUp,
  faSortDown,
  faSort,
  faSearch,
  faBoxOpen,
  faFileImage,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFile,
  faUserCircle,
  faUserAlt,
  faSignOutAlt,
  faHome,
  faMinus,
  faCheck,
  faEnvelope,
  faCube,
  faBars,
  faChartLine,
  faToggleOn,
  faStar,
  faPaperclip,
  faTimes,
  faShare,
  faWarehouse,
  faFileUpload,
  faFileSignature
])

Vue.component('font-awesome-icon', FontAwesomeIcon)
